import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'icon';
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  className = '',
  onClick,
  disabled = false
}) => {
  const baseClasses = 'inline-flex items-center justify-center px-6 py-3 rounded-md font-medium transition-all duration-200 focus:outline-none';
  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-primary-dark',
    secondary: 'border border-black text-black hover:bg-gray-100',
    icon: 'bg-primary text-white hover:bg-primary-dark pr-4'
  };
  const disabledClasses = 'opacity-50 cursor-not-allowed';
  return <button className={`
        ${baseClasses}
        ${variantClasses[variant]}
        ${disabled ? disabledClasses : ''}
        ${className}
      `} onClick={onClick} disabled={disabled} data-id="element-561">
      {children}
      {variant === 'icon' && <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-562" />}
    </button>;
};